/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientOwnerUserRights
 */
export interface ClientOwnerUserRights {
    /**
     * 
     * @type {string}
     * @memberof ClientOwnerUserRights
     */
    binaryRights: string;
}

export function ClientOwnerUserRightsFromJSON(json: any): ClientOwnerUserRights {
    return ClientOwnerUserRightsFromJSONTyped(json, false);
}

export function ClientOwnerUserRightsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientOwnerUserRights {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'binaryRights': json['binary_rights'],
    };
}

export function ClientOwnerUserRightsToJSON(value?: ClientOwnerUserRights | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'binary_rights': value.binaryRights,
    };
}


